// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-kbJVDyI6","slider":"slider-23k1pgNu","container":"container-3J0fgyFB"};